<script>
  import BaseChart  from './ChartBase';
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'DashboardAccountsChart',

    extends: BaseChart,

    computed: { 
      ...mapGetters('dashboards', { dataset: 'byAccount'}),

      title: () => 'Leads by Source',
    },

    methods: {
      ...mapActions('dashboards', { load: 'loadByAccount' }),
    },

  }
</script>
